/*eslint-disable*/
import React from "react";
// react components for routing our app without refresh

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Divider from '@material-ui/core/Divider';


// @material-ui/icons
import Home from "@material-ui/icons/Home";
import Security from "@material-ui/icons/Security";
import VerifiedUser from "@material-ui/icons/VerifiedUser";
import Description from "@material-ui/icons/Description";
import MoreIcon from '@material-ui/icons/MoreVert';
import Info from "@material-ui/icons/Info";
import ContactPhone from '@material-ui/icons/ContactPhone';
import Loyalty from '@material-ui/icons/Loyalty';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ExitToAppRoundedIcon from '@material-ui/icons/ExitToAppRounded';
import { Search } from "@material-ui/icons";
import aboutIcon from "../../../assets/img/icons/abouticon.png"
import contactIcon from "../../../assets/img/icons/contact.png"
import termsIcon from "../../../assets/img/icons/terms.png"
import privacyIcon from "../../../assets/img/icons/privacy.png"
import changepassIcon from "../../../assets/img/icons/changepass.png"

// core components
import Button from "../../CustomButton";

import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import DashboardIcon from '@material-ui/icons/Dashboard';

import headerLinksStyle from "./header-links-style";
import classNames from "classnames";

function HeaderLinks({ ...props }) {
  const { classes, authenticated, logout, loginPage, cookies, tokenBalance, registerPage, baseSubscription, mainpage } = props;
  const anchorRef = React.useRef(null);
  const [open, setOpen] = React.useState(false);
  const handleToggle = (event) => {
    setOpen((prevOpen) => !prevOpen);
  };
  const handleClick = (link) => {
    window.location.href = link;
  };
  const handleAuxClick = (link) => {
    window.open(link, '_blank');
  };
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };
  const handleListKeyDown = (event) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  };
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === true) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);


  let tokens = tokenBalance ? tokenBalance.map(data => {
    if (data.token === 'PLATINUM!!!')
      return data;
    else return null;
  }).filter(Boolean) : null;
  return (
    <List className={classes.list}>
      <ListItem className={authenticated ? classes.listItem : classes.listItem2}>
        <Button
          ref={anchorRef}
          color="inherit"
          className={classes.navLink}
          aria-describedby={open ? 'simplepopover' : undefined}
          aria-controls={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <MoreIcon className={classes.icons} />
        </Button>

        <div className={authenticated ? classes.menuContainer : classes.menuContainer2}>
          <Popper
            id={open ? 'simplepopover' : undefined}
            open={open}
            anchorEl={anchorRef}
            role={undefined}
            transition disablePortal placement="bottom-end">
            {({ TransitionProps, placement }) => (
              <Fade
                {...TransitionProps}
              // style={{ transformOrigin: 'right bottom' }}
              >
                <Paper>
                  <ClickAwayListener
                    onClickAway={handleClose}
                  >
                    <MenuList
                      autoFocusItem={open}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                      className={classes.menuList}>
                      <MenuItem
                        onClick={() => handleClick('/home')}
                        onAuxClick={() => handleAuxClick('/home')}
                      >
                        <Home className={classes.icons} />
                        Home
                      </MenuItem>
                      {authenticated &&
                        <MenuItem
                          onClick={() => handleClick('/dashboard')}
                          onAuxClick={() =>
                            handleAuxClick('/dashboard')}>
                          <DashboardIcon className={classes.icons} />
                          Dashboard
                        </MenuItem>
                      }
                      <Divider className={classes.menuDivider} />
                      <MenuItem
                        onClick={() => handleClick('/aboutus')}
                        onAuxClick={() => handleAuxClick('/aboutus')}>
                        <img src={aboutIcon} alt="about icon" className={classes.iconImage} />
                        About Us
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleClick('/termsofuse')}
                        onAuxClick={() => handleAuxClick('/termsofuse')}>
                        <img src={termsIcon} alt="terms icon" className={classes.iconImage} />
                        Terms of Use
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleClick('/privacy')}
                        onAuxClick={() => handleAuxClick('/privacy')}>
                        <img src={privacyIcon} alt="privacy icon" className={classes.iconImage} />
                        Privacy
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleClick('/contactus')}
                        onAuxClick={() => handleAuxClick('/contactus')}>
                        <img src={contactIcon} alt="contact icon" className={classes.iconImage} />
                        Contact Us
                      </MenuItem>
                      {authenticated ?
                        <div>
                          <Divider className={classes.menuDivider} />
                          <MenuItem
                            onClick={() => handleClick('/changePassword')}
                            onAuxClick={() => handleAuxClick('/changePassword')}>
                            <img src={changepassIcon} alt="change pass icon" className={classes.iconImage} />
                            Change Password
                          </MenuItem>
                          <MenuItem
                            onClick={() => handleClick('/signout')}
                            onAuxClick={() => handleAuxClick('/signout')}>
                            <ExitToAppRoundedIcon className={classes.icons} />
                            Sign Out
                          </MenuItem>
                        </div>
                        :
                        <div>
                          <Divider className={classes.menuDivider} />
                          <MenuItem
                            onClick={() => handleClick('/loginPage')}
                            onAuxClick={() => handleAuxClick('/loginPage')}>
                            <AccountCircleIcon className={classes.icons} />
                            Login
                          </MenuItem>
                        </div>
                      }
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Fade>
            )}
          </Popper>
        </div>
      </ListItem>

      {!loginPage ? (
        authenticated ?
          <div>
            <ListItem className={classes.listItem} >
              <Button
                href="/signout"
                color="inherit"
                className={classes.navLink}
              >
                <ExitToAppRoundedIcon />
              </Button>
            </ListItem>
            <ListItem className={classes.listItem}>
              <Button
                href="/dashboard"
                color="inherit"
                className={classes.navLink}
              >
                {tokens && tokens.length > 0 ? tokens[0].count : ""}
                <DashboardIcon className={classes.icons} />
              </Button>
            </ListItem>
            {/* <ListItem className={classes.listItem}>
              <Button
                href="/verifySSM"
                color="inherit"
                className={classes.navLink}
              >
                <ShoppingCartIcon from className={classes.icons} />
              </Button>
            </ListItem> */}
            <ListItem className={classes.listItem}>
              <Button
                href="/searchBizScreener"
                color="inherit"
                className={classes.navLink}
              >
                <Search from className={classes.icons} />
              </Button>
            </ListItem>
          </div>
          :
          <div>
            <ListItem className={classes.listItem2} style={{ marginLeft: "0px", marginRight: "-10px" }}>
              <Button
                href="/loginPage"
                color="inherit"
                className={classes.navLink}
              >
                <AccountCircleIcon />
              </Button>
            </ListItem>
            <ListItem className={classes.listItem2}>
              <Button
                href="/loginPage"
                color="transparent"
                className={classes.navLink}
              >
                Service
              </Button>
            </ListItem>
            <ListItem className={classes.listItem2}>
              <Button
                href="/home#contactus"
                color="transparent"
                className={classes.navLink}
              >
                Contact Us
              </Button>
            </ListItem>
            <ListItem className={classes.listItem2}>
              <Button
                href="/aboutus"
                color="transparent"
                className={classes.navLink}
              >
                About
              </Button>
            </ListItem>
          </div>

      ) : ""
      }
      {
        !authenticated ?
          <ListItem className={classes.listItem}>
            <Button
              href={"/home"}
              color="transparent"
              className={classes.navLink}
            >
              Home
            </Button>
          </ListItem> : ''
      }

    </List>
  );
}

export default withStyles(headerLinksStyle)(HeaderLinks);
